import React, { useState } from "react";
import { Button, ButtonGroup, Form } from "react-bootstrap";
import { enums } from "../../../data";
import { useDispatch, useSelector } from "react-redux";
import { setApplications } from "../../../state/slices/application";
import { useGetCoursesQuery } from "../../../state/services/course";

// This component renders a section where user can select a course and then click
// on the "rank" button to rank all the applications.
// When the rank button is clicked, a score is assigned to each applicant. The applicants
// are sorted based on this score. A score colum is added to the right side of the Ag-Grid
// to display this score.
// The score is calculated based on interest, experience, grade and GPA.
function RankApplicationComponent(props) {
  const { year, term, gridApi, gridColumnApi } = props;
  const [course, setCourse] = useState("");

  const applications = useSelector((state) => state.applications.records);
  const dispatch = useDispatch();

  const { data: courses } = useGetCoursesQuery({ year, term });

  const rankApplications = (event) => {
    event.preventDefault();

    // Update column definition
    const columnDefs = gridApi.getColumnDefs();
    if (columnDefs[columnDefs.length - 1].field !== "score") {
      const colDef = [
        ...columnDefs,
        {
          field: "score",
          headerName: "Score",
          pinned: "right",
          width: 110,
          filter: "agNumberColumnFilter",
          editable: false,
          comparator: (valueA, valueB, nodeA, nodeB, isInverted) =>
            Number(valueA) - Number(valueB),
        },
      ];
      // setColumnDefs(colDef);
      gridApi.setColumnDefs(colDef);
    }

    // calculate score
    const apps = [];
    for (let i = 0; i < applications.length; i++) {
      const app = applications[i];
      let score = 0;

      // here comes the logic!
      if (app.course1 === course) {
        score = 8;
        score += enums.courseExperience.indexOf(app.experience1);
        score +=
          (enums.grades.length - enums.grades.indexOf(app.grade1) - 1) / 2.0;
      } else if (app.course2 === course) {
        score = 6;
        score += enums.courseExperience.indexOf(app.experience2);
        score +=
          (enums.grades.length - enums.grades.indexOf(app.grade2) - 1) / 2.0;
      } else if (app.course3 === course) {
        score = 4;
        score += enums.courseExperience.indexOf(app.experience3);
        score +=
          (enums.grades.length - enums.grades.indexOf(app.grade3) - 1) / 2.0;
      } else if (app.course4 === course) {
        score = 2;
        score += enums.courseExperience.indexOf(app.experience4);
        score +=
          (enums.grades.length - enums.grades.indexOf(app.grade4) - 1) / 2.0;
      } else {
        score = 0;
      }

      score += app.gradePointAverage / 4.0;
      score += enums.teachingExperience.indexOf(app.experience) / 2.0;

      apps.push({ ...app, score: score.toFixed(2) });
    }

    dispatch(setApplications(apps));

    // clear sort
    gridColumnApi.applyColumnState({ defaultState: { sort: null } });
    // sort the score column
    gridColumnApi.applyColumnState({
      state: [
        {
          colId: "score",
          sort: "desc",
        },
      ],
      defaultState: { sort: null },
    });

    gridApi.redrawRows();
  };

  const clearRanks = (event) => {
    event.preventDefault();

    // Update column definition
    const columnDefs = gridApi.getColumnDefs();
    if (columnDefs[columnDefs.length - 1].field === "score") {
      const colDef = columnDefs;
      colDef.pop();
      gridApi.setColumnDefs(colDef);
    }

    dispatch(
      setApplications(
        applications.map((app) => {
          const { score, ...rest } = app;
          return rest;
        })
      )
    );

    // clear sort
    gridColumnApi.applyColumnState({ defaultState: { sort: null } });

    gridApi.redrawRows();
  };

  return (
    <Form size={"sm"}>
      <Form.Label size={"sm"}>Select your course</Form.Label>
      <Form.Control
        size={"sm"}
        name={"course"}
        as={"select"}
        type={"text"}
        onChange={(e) => setCourse(e.target.value)}
        value={course}
      >
        {courses &&
          courses.map((option, ind) => {
            return (
              <option key={ind} value={option}>
                {option}
              </option>
            );
          })}
      </Form.Control>
      <ButtonGroup size={"sm"}>
        <Button
          className={"section-button"}
          variant={"outline-danger"}
          onClick={clearRanks}
        >
          Clear
        </Button>
        <Button
          className={"section-button"}
          type={"button"}
          onClick={rankApplications}
        >
          Rank and Sort
        </Button>
      </ButtonGroup>
    </Form>
  );
}

export default RankApplicationComponent;
